import { render, staticRenderFns } from "./TheBuildingDetailsForm.vue?vue&type=template&id=5bb81932&"
import script from "./TheBuildingDetailsForm.vue?vue&type=script&lang=js&"
export * from "./TheBuildingDetailsForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports